import React from 'react'
import { Link } from "react-router-dom";
import coreImg2 from "../assets/img/home3/block2.png";
import coreImg1 from "../assets/img/ProductsDetails/AboutOilCakes.jpg";
import PageBanner from "../Components/PageBanner";
import bannerBg from '../assets/img/Banners/Productpagebanner.jpg';
const OilCakes = () => {
  return (
    <>
      
      <PageBanner title='Oil Cakes ' bannerBg={bannerBg} currentPage=' Oil Cakes' />
      <section className="content-block-wrapper section-padding bg-circle fix">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-xl-6 col-lg-6 pe-xl-4 col-12">
              <div className="content-block-img justify-content-center">
                <img src={coreImg1} alt="" />
              </div>
            </div>
            <div className="col-xl-6 ps-xl-5 col-lg-6 col-12 mt-5 mt-lg-0">
              <div className="section-title-3">
                {/* <h6>Core Features</h6> */}
                <h2>About Oil Cakes 
                </h2>
                <h6>(Cattle Feeds)</h6>
                <p>
                In India, cattle, livestock, and poultry play a vital role in the rural economy. However, the availability of quality fodder and nutritious feed has been a persistent challenge. Addressing this need, the company introduced "SHREE GITA", a well-balanced cattle feed designed to support healthier livestock. 
                </p>
                <br></br>
                <p>
                Formulated with an optimal blend of proteins, carbohydrates, fats, vitamins, and minerals, this pellet-based compound feed helps farmers enhance milk production and improve their livelihoods. 
                </p>
                <br></br>
                <p>
                The company operates a state-of-the-art facility with a 250 MT per day production capacity and an advanced Quality Control Laboratory to ensure superior feed quality. 
                </p>
                <br></br>
               
              </div>
              {/* <div className="checked-features-list style-2">
                <ul>
                  <li>Brand Identity</li>
                  <li>Website Design &amp; Development</li>
                  <li>SEO &amp; Analytics</li>
                </ul>
              </div> */}
              <Link to="/about" className="theme-btn style-3 mt-30">
                click here
              </Link>
            </div>
          </div>
         
        </div>
      </section>    
    </>
  )
}

export default OilCakes
